import { lazy, Suspense } from "react";
import AuthGuard from "./components/AuthGuard";
import DashboardLayout from "./components/DashboardLayout";
import GuestGuard from "./components/GuestGuard";
import MainLayout from "./components/MainLayout";
import { Class } from "@mui/icons-material";
import { CircularProgress } from "@mui/material";
import DiscoveryHome from "./DiscoveryPortal/Home";
import Listing from "./DiscoveryPortal/Listing";
import ComapnyDetail from "./DiscoveryPortal/CompanyDetail";

// const Loadable = (Component) => (props) =>
// (
//   <Suspense
//     fallback={<CircularProgress
//       className=" m-5  "
//     />}
//   >

//     <Component {...props} />

//   </Suspense>
// );

const Loadable = (Component) => (props) =>
  (
    <Suspense
      fallback={
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
          }}
        >
          {/* <div style={{
          // .three-quarter-spinner {
          width: " 50px",
          height: "50px",
          border: " 3px solid #6f42c1",
          borderTop: "3px solid transparent",
          borderRadius: "50%",
          animation: "spin .5s linear 0s infinite",
          // }
        }}></div> */}
          <CircularProgress style={{}} />
        </div>
      }
    >
      <Component {...props} />
    </Suspense>
  );

const Landing = Loadable(lazy(() => import("./pages/Landing")));
const ForgotPassword = Loadable(lazy(() => import("./pages/ForgotPassword")));
const Register = Loadable(lazy(() => import("./pages/Register")));
const Home = Loadable(lazy(() => import("./pages/Home")));
const Cards = Loadable(lazy(() => import("./pages/cards")));
const AccountPage = Loadable(lazy(() => import("./pages/Account Settings")));
const ResetPassword = Loadable(lazy(() => import("./pages/ResetPassword")));
const Prospect = Loadable(lazy(() => import("./pages/Prospect")));
const Notifications = Loadable(lazy(() => import("./pages/Notifications")));
const List = Loadable(lazy(() => import("./pages/List")));
const IntelliConnect = Loadable(lazy(() => import("./pages/IntelliConnect")));
const Subscription = Loadable(lazy(() => import("./pages/Account Settings/Subscription")));
const Loader = Loadable(lazy(() => import("./pages/loader")));
const Failed = Loadable(lazy(() => import("./pages/PaymentFailed")));
const SuccessPayment = Loadable(lazy(() => import("./pages/PaymentSuccess")));



const routes = [
  {
    path: "/",
    element: <MainLayout />,
    children: [
      {
        path: "/login",
        element: (
          <GuestGuard>
            <Landing />
          </GuestGuard>
        ),
      },
      {
        path: "/forgotpassword",
        element: (
          <GuestGuard>
            <ForgotPassword />
          </GuestGuard>
        ),
      },
      {
        path: "/Register",
        element: (
          <GuestGuard>
            <Register />
          </GuestGuard>
        ),
      },
      {
        path: "/cards",
        element: (
          <GuestGuard>
            <Cards/>
          </GuestGuard>
        ),
      },
      {
        path: "/Subscription",
        element: (
          <GuestGuard>
            <Subscription/>
          </GuestGuard>
        ),
      },
      //Subscription
      {
        path: "/resetpassword/:token",
        element: (
          <GuestGuard>
            <ResetPassword />
          </GuestGuard>
        ),
      },
      {
        path: "/",
        element: (       
            <DiscoveryHome />
          
        ),
      },
      {
        path: "/listing",
        element: (       
            <Listing/>
          
        ),
      },
      {
        path: "/loader",
        element: (       
            <Loader/>
          
        ),
      },
      {
        path: "/payment/failed",
        element: (       
            <Failed/>
          
        ),
      },
      {
        path: "/payment/success",
        element: (       
            <SuccessPayment/>
          
        ),
      },
      {
        path: "/discovery/detail/:id",
        element: (
       
            <ComapnyDetail />
       
        ),
      },
    ],
  },
  {
    path: "/",
    element: (
      <AuthGuard>
        <DashboardLayout />
      </AuthGuard>
    ),
    children: [
      {
        path: "dashboard",
        element: (
          <AuthGuard>
            <Home />
          </AuthGuard>
        ),
      },
      {
        path: "account",
        element: (
          <AuthGuard>
            <AccountPage />
          </AuthGuard>
        ),
      },
      {
        path: "prospect",
        element: (
          <AuthGuard>
            <Prospect />
          </AuthGuard>
        ),
      },
      {
        path: "/listing",
        element: (
          <AuthGuard>
            <Listing/>
          </AuthGuard>
        ),
      },
     
      {
        path: "list",
        element: (
          <AuthGuard>
            <List />
          </AuthGuard>
        ),
      },
      {
        path: "notifications",
        element: (
          <AuthGuard>
            <Notifications />
          </AuthGuard>
        ),
      },
      {
        path: "intelliConnect",
        element: (
          <AuthGuard>
            <IntelliConnect />
          </AuthGuard>
        ),
      },
    ],
  },
];

export default routes;
